export default {
	postingSalaries: 'ترحيل الرواتب',
	tabs: {
		summary: 'ملخص',
		details: 'مفصل',
	},
	summaryTable: {
		date: 'التاريخ',
		section: 'القسم',
		baseSalary: 'الراتب',
		absenceDiscount: 'خصم الغياب',
		lateAndEarlyDiscount: 'خصم التاخير والانصراف',
		financialPenalty: 'عقوبات مالية',
		financialRewards: 'مكافئات مالية',
		extra: 'إضافي',
		finalSalary: 'راتب نهائي',
	},
	detailsTable: {
		date: 'التاريخ',
		section: 'القسم',
		chipNo: 'رقم الشريحة',
		month: 'الشهر',
		year: 'السنة',
		baseSalaryOnStart: 'اساس الراتب عند مباشرة العمل',
		baseSalaryOnAdmission: 'اساس الراتب بعد التثبيت',
		academic: 'المؤهل العلمي',
		practical: 'الخبرة العملية',
		quality: 'بدل كفاءة',
		responsibility: 'بدل مسؤولية',
		inflation: 'بدل غلاء معيشيي',
		food: 'بدل طعام',
		travel: 'بدل سفر',
		seniority: 'الأقدمية الوظيفية',
		penaltiesAndRewards: 'مكافئات وعقوبات',
	},
};
